export default __webpack_public_path__ + "static/media/letiycialves.ab68adf3.jpg";